"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssetsSourceEnum = exports.GetAssetOverviewByCategorySourceEnum = exports.GetAssetCategorySeverityOverviewSourceEnum = exports.GetAssetCategoryActionClassOverviewSourceEnum = exports.GetAssetActionClassOverviewSourceEnum = exports.AssetApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var AssetApi = /** @class */ (function (_super) {
    __extends(AssetApi, _super);
    function AssetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Request to delete multiple devices. If one of the devices in the list fails to delete; then MultiStatus is returned. The error corresponds to the asset ID in the metadata list.
     * Request to delete multiple devices
     */
    AssetApi.prototype.bulkDeleteAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling bulkDeleteAsset.');
                        }
                        if (requestParameters.bulkAssetDeleteRequest === null || requestParameters.bulkAssetDeleteRequest === undefined) {
                            throw new runtime.RequiredError('bulkAssetDeleteRequest', 'Required parameter requestParameters.bulkAssetDeleteRequest was null or undefined when calling bulkDeleteAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/bulkAssetDelete".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.BulkAssetDeleteRequestToJSON)(requestParameters.bulkAssetDeleteRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Request to delete multiple devices. If one of the devices in the list fails to delete; then MultiStatus is returned. The error corresponds to the asset ID in the metadata list.
     * Request to delete multiple devices
     */
    AssetApi.prototype.bulkDeleteAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkDeleteAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Patch assets for a given customer ID
     * Patch assets
     */
    AssetApi.prototype.bulkEditAssetsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling bulkEditAssets.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.assetsCatalogsInner.map(models_1.AssetsCatalogsInnerToJSON),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AssetsCatalogsInnerFromJSON); })];
                }
            });
        });
    };
    /**
     * Patch assets for a given customer ID
     * Patch assets
     */
    AssetApi.prototype.bulkEditAssets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkEditAssetsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add asset note for a given customer ID and asset ID
     * Add asset note
     */
    AssetApi.prototype.createAssetNotesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling createAssetNotes.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling createAssetNotes.');
                        }
                        queryParameters = {};
                        if (requestParameters.note !== undefined) {
                            queryParameters['note'] = requestParameters.note;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets/{assetID}/notes".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add asset note for a given customer ID and asset ID
     * Add asset note
     */
    AssetApi.prototype.createAssetNotes = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAssetNotesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete asset note matching the given customer ID and asset ID
     * Delete asset note
     */
    AssetApi.prototype.deleteAssetNoteRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling deleteAssetNote.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling deleteAssetNote.');
                        }
                        if (requestParameters.noteID === null || requestParameters.noteID === undefined) {
                            throw new runtime.RequiredError('noteID', 'Required parameter requestParameters.noteID was null or undefined when calling deleteAssetNote.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets/{assetID}/notes/{noteID}".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))).replace("{".concat("noteID", "}"), encodeURIComponent(String(requestParameters.noteID))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete asset note matching the given customer ID and asset ID
     * Delete asset note
     */
    AssetApi.prototype.deleteAssetNote = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAssetNoteRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Patch asset object matching the given customer ID and asset ID
     * Patch asset object
     */
    AssetApi.prototype.editAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling editAsset.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling editAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/dashboard/customers/{customerID}/assets/{assetID}".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.EditAssetRequestToJSON)(requestParameters.editAssetRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch asset object matching the given customer ID and asset ID
     * Patch asset object
     */
    AssetApi.prototype.editAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get asset object matching the given customer ID and asset ID
     * Get asset object
     */
    AssetApi.prototype.getAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAsset.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling getAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets/{assetID}".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get asset object matching the given customer ID and asset ID
     * Get asset object
     */
    AssetApi.prototype.getAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get asset action class overview
     */
    AssetApi.prototype.getAssetActionClassOverviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetActionClassOverview.');
                        }
                        queryParameters = {};
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/asset-action-class-overview".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssetActionClassOverviewFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get asset action class overview
     */
    AssetApi.prototype.getAssetActionClassOverview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetActionClassOverviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get asset activities associated with the customer
     */
    AssetApi.prototype.getAssetActivitesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
                            throw new runtime.RequiredError('uuid', 'Required parameter requestParameters.uuid was null or undefined when calling getAssetActivites.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{uuid}/asset_activities".replace("{".concat("uuid", "}"), encodeURIComponent(String(requestParameters.uuid))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AssetActivityFromJSON); })];
                }
            });
        });
    };
    /**
     * Get asset activities associated with the customer
     */
    AssetApi.prototype.getAssetActivites = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetActivitesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetCategoryActionClassOverviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetCategoryActionClassOverview.');
                        }
                        queryParameters = {};
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assetCategoryActionClassOverview".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RiskVisualizationChartFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetCategoryActionClassOverview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetCategoryActionClassOverviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetCategorySeverityOverviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetCategorySeverityOverview.');
                        }
                        queryParameters = {};
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assetCategorySeverityOverview".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RiskVisualizationChartFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetCategorySeverityOverview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetCategorySeverityOverviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get asset histories matching the given customer ID and asset ID
     * Get asset histories
     */
    AssetApi.prototype.getAssetHistoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetHistory.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling getAssetHistory.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets/{assetID}/histories".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AssetHistoriesInnerFromJSON); })];
                }
            });
        });
    };
    /**
     * Get asset histories matching the given customer ID and asset ID
     * Get asset histories
     */
    AssetApi.prototype.getAssetHistory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetHistoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get asset notes matching the given customer ID and asset ID
     * Get asset notes
     */
    AssetApi.prototype.getAssetNotesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetNotes.');
                        }
                        if (requestParameters.assetID === null || requestParameters.assetID === undefined) {
                            throw new runtime.RequiredError('assetID', 'Required parameter requestParameters.assetID was null or undefined when calling getAssetNotes.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets/{assetID}/notes".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))).replace("{".concat("assetID", "}"), encodeURIComponent(String(requestParameters.assetID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssetNotesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get asset notes matching the given customer ID and asset ID
     * Get asset notes
     */
    AssetApi.prototype.getAssetNotes = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetNotesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetOverviewByCategoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssetOverviewByCategory.');
                        }
                        queryParameters = {};
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        if (requestParameters.actionClass) {
                            queryParameters['actionClass'] = requestParameters.actionClass;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assetOverviewByCategory".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssetCategoriesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetOverviewByCategory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetOverviewByCategoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssetsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerID === null || requestParameters.customerID === undefined) {
                            throw new runtime.RequiredError('customerID', 'Required parameter requestParameters.customerID was null or undefined when calling getAssets.');
                        }
                        queryParameters = {};
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        if (requestParameters.criticality !== undefined) {
                            queryParameters['criticality'] = requestParameters.criticality;
                        }
                        if (requestParameters.tagID !== undefined) {
                            queryParameters['tagID'] = requestParameters.tagID;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/rootsecure/v1/customers/{customerID}/assets".replace("{".concat("customerID", "}"), encodeURIComponent(String(requestParameters.customerID))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetAssets200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer assets group by category
     */
    AssetApi.prototype.getAssets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AssetApi;
}(runtime.BaseAPI));
exports.AssetApi = AssetApi;
/**
 * @export
 */
exports.GetAssetActionClassOverviewSourceEnum = {
    Sensor: 'sensor',
    Reach: 'reach',
    Agent: 'agent'
};
/**
 * @export
 */
exports.GetAssetCategoryActionClassOverviewSourceEnum = {
    Sensor: 'sensor',
    Reach: 'reach',
    Agent: 'agent'
};
/**
 * @export
 */
exports.GetAssetCategorySeverityOverviewSourceEnum = {
    Sensor: 'sensor',
    Reach: 'reach',
    Agent: 'agent'
};
/**
 * @export
 */
exports.GetAssetOverviewByCategorySourceEnum = {
    Sensor: 'sensor',
    Reach: 'reach',
    Agent: 'agent'
};
/**
 * @export
 */
exports.GetAssetsSourceEnum = {
    Sensor: 'sensor',
    Reach: 'reach',
    Agent: 'agent'
};
